// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import createAnalytics from '../thirdparty/analytics';
import createTagManager from '../thirdparty/tagmanager';
import { findSection, rewritePath } from '../utils/routeUtils';

type Props = {
  history: Object,
  children: Array<React.Node>,
  googleAnalyticsId?: string,
  googleTagManagerId?: string,
  rewriteRules: { [key: string]: string }
};

type State = {
  referrer?: string,
  referrerName: string
};

class HistoryListener extends React.Component<Props, State> {
  props: Props;

  state: State;

  static defaultProps = {
    googleAnalyticsId: undefined,
    googleTagManagerId: undefined
  };

  unlisten: () => void; // eslint-disable-line react/sort-comp

  constructor(props: Props, ...rest: Array<*>) {
    super(props, ...rest);

    const { history, rewriteRules } = props;
    const { pathname } = history.location;
    const section = findSection({
      rewriteRules
    })(pathname);

    this.state = section
      ? {
          referrer: pathname,
          referrerName: section.name
        }
      : {
          referrer: '/lobby',
          referrerName: 'Lobby'
        };
  }

  componentDidMount() {
    const { history, googleAnalyticsId, googleTagManagerId, rewriteRules } = this.props;
    const { referrer, referrerName } = this.state;

    if (googleAnalyticsId) {
      createAnalytics(googleAnalyticsId);
      window.ga('send', {
        hitType: 'pageview',
        page: history.location.pathname
      });
    }

    if (googleTagManagerId) {
      createTagManager(googleTagManagerId);
      window.dataLayer.push({
        event: 'VirtualPageview',
        virtualPageTitle: document.title,
        virtualPageURL: history.location.pathname
      });
    }

    this.unlisten = history.listen((location, action) => {
      const { pathname } = location;
      const rewrite = rewritePath(rewriteRules);

      if (action === 'PUSH') {
        if (googleAnalyticsId) {
          window.ga('send', {
            hitType: 'pageview',
            page: location.pathname
          });
        }

        if (googleTagManagerId) {
          window.dataLayer.push({
            event: 'VirtualPageview',
            virtualPageTitle: document.title,
            virtualPageURL: location.pathname
          });
        }

        const section = findSection({ rewriteRules })(pathname);
        if (section) {
          this.setState({
            referrer: pathname,
            referrerName: section.name
          });
        } else if (
          pathname.startsWith(rewrite('/challenge/')) ||
          pathname.startsWith('/rapidfire/') ||
          pathname.startsWith(rewrite('/training/'))
        ) {
          history.replace({
            ...location,
            state: {
              referrer,
              referrerName
            }
          });
        }
      }
    });
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

function mapStateToProps(state) {
  return {
    googleAnalyticsId: state.settings.googleAnalyticsId,
    googleTagManagerId: state.settings.googleTagManagerId,
    rewriteRules: state.settings.rewriteRules
  };
}

const connector = compose(withRouter, connect(mapStateToProps));

export default connector(HistoryListener);
